class ReportPageService {
  /**
   * Extract child blocks in the flat block list and nest them inside their corresponding parent block
   * The flat block list is useful for editing, but we convert to the nested structure to make it easier for rendering
   */
  moveChildBlocksToParent (layoutBlocks) {
    const blocks = []
    const childBlocks = []

    layoutBlocks.forEach((block) => {
      if (block.props && block.props.parentBlock) {
        childBlocks.push(block)
      } else {
        blocks.push(block)
      }
    })

    // Push the children into a childBlocks prop on it's parent so the parent can manage rendering it's children
    childBlocks.forEach((childBlock) => {
      const parentBlock = blocks.find(({ key }) => key === childBlock.props.parentBlock.key)
      if (parentBlock) {
        parentBlock.props = { ...(parentBlock.props || {}) }
        parentBlock.props.childBlocks = parentBlock.props.childBlocks || []
        parentBlock.props.childBlocks.push(childBlock)
      }
    })

    return blocks
  }
}

export const reportPageService = new ReportPageService()
